export default "__VITE_ASSET__HneWQtk4__"